<template>
  <form
    action="#"
    :class="[$attrs.class, { show: state.isShowSearchInput }]"
    @submit.prevent="search"
    @keyup.enter="search">
    <button @click.prevent="clickToIcon" type="submit" class="search-submit show">
      <svg class="icon-search">
        <use href="/sprite.svg#search"></use>
      </svg>
    </button>

    <button
      :class="['search-submit clear', { show: state.searchString && state.searchString.length > 0 }]"
      @click.prevent="clearText">
      <div class="icon-custom-close">
        <span class="close-row"></span>
        <span class="close-row"></span>
      </div>
    </button>
    <input
      @click="showResultsBlock"
      class="search-input input"
      v-model="state.searchString"
      type="text"
      :placeholder="trans('header.search.placeholder')" />
    <div v-if="state.isVisibleSearchResults" class="search-results">
      <div class="results-list">
        <div class="label-category">{{ trans("header.search.suggestion") }}</div>
        <span
          v-for="(key, text) in state.data.categories"
          :key="`${key}-${text}`"
          class="search-item"
          @click="selectSuggestion(text)">
          {{ text }}
        </span>
        <span
          v-for="(key, text) in state.data.tags"
          :key="`${key}-${text}`"
          class="search-item"
          @click="selectSuggestion(text)">
          {{ text }}
        </span>
      </div>
      <div class="search-options">
        <div class="checkbox-item">
          <input class="checkbox-input" type="checkbox" id="filter-stamps-1" v-model="state.includePast" />
          <label class="checkbox-label" for="filter-stamps-1">
            <span class="checkmark"></span>
            {{ trans("header.search.include_past_auctions") }}
          </label>
        </div>
      </div>
    </div>
  </form>

  <div class="modal-overlay" v-show="state.isVisibleSearchResults" @click="closeResultsBlock"></div>
</template>

<script setup lang="ts">
  import { computed, reactive, watch } from "vue";
  import apiClient from "@/services/api";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { trans } from "@/utils/trans";

  const state = reactive({
    isShowSearchInput: false,
    isVisibleSearchResults: false,
    searchString: "",
    includePast: false,
    timerId: null as null | number,
    filterTimerId: null as null | number,
    lastResponse: null as null | number,
    data: []
  });

  const auctionStore = useAuctionStore();
  const resultUrl = computed(() => auctionStore.routes["site.lots.show_catalog"]);
  const autocompleteUrl = computed(() => auctionStore.routes["site.search.autocomplete"]);

  const resultHref = computed(() => {
    const url = new URL(resultUrl.value, window.location.origin);

    if (state.searchString?.length) {
      url.searchParams.set("searchText", state.searchString);
    } else {
      url.searchParams.delete("searchText");
    }
    url.searchParams.set("auctionStatus", state.includePast ? "past" : "upcoming");
    url.searchParams.set("sortBy", "auction_date");

    return url.toString();
  });

  watch(
    () => state.searchString,
    (nv) => {
      if (state.timerId) {
        clearTimeout(state.timerId);
      }

      if (nv && nv.length >= 1) {
        state.timerId = setTimeout(autocomplete, 600);
      }
    }
  );

  const clickToIcon = () => {
    if (state.searchString && state.searchString.length >= 2) {
      search();
    } else {
      state.isVisibleSearchResults = false;
      state.isShowSearchInput = !state.isShowSearchInput;
    }
  };

  const autocomplete = () => {
    const time = Date.now();
    state.lastResponse = time;
    const queryParam = new URLSearchParams({
      auctionStatus: state.includePast ? "past" : "upcoming",
      q: state.searchString
    });
    apiClient
      .get(`${autocompleteUrl.value}?${queryParam}`)
      .then((response) => {
        if (state.lastResponse <= time) {
          state.data = response.data;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const clearText = () => {
    state.searchString = "";
    state.showResultsBlock = false;
    state.data = [];
  };

  const search = () => {
    if (state.searchString && state.searchString.length >= 1) {
      window.location = resultHref.value as any;
    }
  };

  const showResultsBlock = () => {
    state.isVisibleSearchResults = true;
  };

  const closeResultsBlock = () => {
    state.isVisibleSearchResults = false;

    if (!state.searchString?.length) {
      state.isShowSearchInput = false;
    }
  };

  const selectSuggestion = (text: string) => {
    state.searchString = text;
    search();
  };
</script>
